/**
 * BrandOutro: the one ConfirmPH logo animation/video asset, reused as the
 * closing beat of every public homepage demo (renter normal, renter issue,
 * business normal, business issue). Device-dependent (phone vs desktop
 * source video), muted/looping/autoplaying, no controls, no copy - a short
 * branded pause after the real demo's final state, not another step with
 * instructions. See public/videos/confirmph-outro-{phone,desktop}.mp4.
 *
 * Originally private to RenterWalkthroughStage.jsx (the renter normal
 * flow's own "outro" step); extracted here so the renter issue flow and
 * both business-homepage flows can reuse the exact same asset/markup
 * instead of each growing their own copy.
 */
export default function BrandOutro({ deviceMode = "desktop", screenTestId = "walkthrough-outro-screen", videoTestId = "walkthrough-outro-video" }) {
  const src = deviceMode === "phone" ? "/videos/confirmph-outro-phone.mp4" : "/videos/confirmph-outro-desktop.mp4";
  return (
    <div className="w-full h-full min-h-[400px] bg-slate-950 flex items-center justify-center" data-testid={screenTestId}>
      <video
        key={src}
        src={src}
        autoPlay
        muted
        loop
        playsInline
        className="max-w-full max-h-full"
        data-testid={videoTestId}
      />
    </div>
  );
}
